module.exports = __webpack_public_path__ + "static/media/logoWithText.1de00def.svg";